


/* TODO: Split this component into smaller components. */
import { Component, Vue, Watch } from "vue-property-decorator";

import { PagerSorter, TextFilter } from "@Internal/Models";

import { Plans, Prices, Products, Subscriptions } from "App";

import {
    NewProduct,
    Product,
    Plan,
    CustomNotification,
    Field
} from "App/Models";

import { Dictionary } from "App/Contracts";
import { MigrateFailure, MigrationCandidate } from "App/Contracts/Subscriptions";

import { EventBus, $t } from "App/IOC";

import { RecordActions, RecordAction } from "Web/Contracts";

import ProductForm from "./Form.vue";

import Record from "Web/Components/Record.vue";
import Accordion from "Web/Components/Accordion.vue";
import PopupWindow from "Web/Components/Popup/Window.vue";
import BooleanField from "Web/Components/Common/Input/Boolean.vue";

@Component({
    components: {
        Accordion,
        ProductForm,
        Record,
        PopupWindow,
        BooleanField
    }
})
export default class SingleProductView extends Vue {
    private record: Product = NewProduct();

    private fields: Dictionary<Field> = {};

    private showScenarios: boolean = false;
    private editing: boolean = false;
    private loading: boolean = true;
    private plansPagerSorter: PagerSorter = PagerSorter.ForColumn(
        Products.Columns.GetDefaultSort()
    );

    private pricesPagerSorter: PagerSorter = PagerSorter.ForColumn(
        Prices.Columns.GetDefaultSort()
    );

    private actions: RecordActions<Product> = [
        [
            {
                Id: "MigratePrices",
                Title: $t( "SUBSCRIPTIONS_migrateAllAction" ),
                Icon: "autorenew"
            }
        ]
    ];

    /* Plan-picker modal for the price migration + the plans selected in it. */
    private showMigrate: boolean = false;

    /* LES COMPTES A COCHER ( Fred, 08/10/2026 : « avoir la liste des comptes sur lesquels on va
       appliquer ce nouveau prix et pouvoir selectionner moi-meme les comptes concernes » ) — la
       fenetre passe par deux etapes : les plans, puis les comptes avec leur montant avant / apres.
       Seuls les comptes coches sont migres. */
    private migrateStep: "plans" | "accounts" = "plans";
    private candidates: MigrationCandidate[] = [];
    private candidatesLoading: boolean = false;
    private selectedSubscriptionIds: number[] = [];
    private candidateSearch: string = "";
    private migrating: boolean = false;
    private selectedPlanIds: number[] = [];

    /* Live progress of the chunked-cursor migration, shown while it loops over batches. */
    private migrateProgress?: {
        Examined: number;
        Total: number;
        Migrated: number;
    } = undefined;

    /* Determinate fill width (%) once a batch reported a Total. Clamped so the snap-to-100% final
       state never overflows. */
    private get migrateBarPercent(): number {
        if( this.migrateProgress === undefined || this.migrateProgress.Total <= 0 )
            return 0;

        const ratio = this.migrateProgress.Examined / this.migrateProgress.Total;

        return Math.min( 100, Math.max( 0, ratio * 100 ) );
    }

    private created() {
        this.setup();
    }

    private async setup() {
        this.fields = await Products.Fields.Get();

        /* TODO: Handle invalid ID format. */
        await this.getProduct( true );

        if( this.record.Name === undefined )
            return;

        document.title = this.record.Name;
    }

    /* Reset data on Product change*/
    private resetData() {
        this.fields = {};
        this.record = NewProduct();
    }

    /* Refresh data if navigated to a different Product
        diractly from the current page. */
    @Watch( "$route" )
    private onRouteParametersChange( from: any, to: any ) {
        if( to.name !== "product" || from.params.id === to.params.id )
            return;
        this.resetData();
        this.setup();
    }

    private async save( record: Product ) {
        if( this.record === undefined || record === undefined )
            return;

        const [ , error ] = await Products.Update( this.record, record );

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        await this.getProduct();
    }


    private async getProduct( silent: boolean = false ) {
        const [ record, error ] = await Products.Get( Number( this.$route.params.id ) );

        if( error !== undefined || record === undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        /* Get plans. */
        let filter = new TextFilter( "ProductId", "" );
        filter.Value = [ record.Id ];

        const [ plans, , planError ] = await Plans.Find(
            [ filter ],
            this.plansPagerSorter
        );

        if( planError !== undefined ) {
            EventBus.Publish( "Error", planError );
            return;
        }

        /* Get product prices. */
        filter = new TextFilter( "ProductId", "" );
        filter.Value = [ record.Id ];
        const scopefilter = new TextFilter( "Global", "" );
        scopefilter.Value = [ true ];

        const [ prices, , priceError ] = await Prices.Find(
            [ filter, scopefilter ],
            this.pricesPagerSorter
        );

        if( priceError !== undefined ) {
            EventBus.Publish( "Error", priceError );
            return;
        }

        record.Prices = prices;

        for( const plan of plans ) {
            /* Get prices. */
            filter = new TextFilter( "PlanId", "" );
            filter.Value = [ plan.Id ];

            const [ prices, , priceError ] = await Prices.Find(
                [ filter ],
                this.pricesPagerSorter
            );

            if( priceError !== undefined ) {
                EventBus.Publish( "Error", priceError );
                return;
            }

            plan.Prices = prices;
            record.Prices = record.Prices.concat( prices );
        }

        record.Plans = plans;

        this.record = record as Product;

        if( !silent )
            this.showUpdateNotification();
    }

    private showUpdateNotification() {
        EventBus.Publish( "Notification", CustomNotification.Success(
            this.$t( "GLOBAL_Product" ).toString(), this.$t( "PRODUCTS_updated" ).toString()
        ));
    }

    private underConstruction() {
        EventBus.Publish( "UnderConstruction" );
    }

    private update( product: Product, silent: boolean = false ) {
        this.record = product;

        if( !silent )
            this.showUpdateNotification();
    }

    private execute( action: RecordAction ): void {
        switch( action.Id ) {
            case "MigratePrices":
                this.openMigrate();
                break;

            default:
                EventBus.Publish( "UnderConstruction" );
                break;
        }
    }

    /* Open the migration picker. Re-pricing existing customers is a heavy, never-by-accident
       action, so instead of a blind confirm we let the user pick which plan(s) to migrate. Every
       plan is preselected by default, keeping the original "apply to all" behaviour one click
       away. */
    private openMigrate(): void {
        if( this.migrating )
            return;

        this.selectedPlanIds = this.record.Plans.map( ( plan: Plan ): number => plan.Id );
        this.migrateStep = "plans";
        this.candidates = [];
        this.selectedSubscriptionIds = [];
        this.candidateSearch = "";
        this.showMigrate = true;
    }

    /* Etape 2 : les comptes des plans choisis qui ne sont pas aux tarifs publies, tous coches. */
    private async loadCandidates(): Promise<void> {
        this.migrateStep = "accounts";
        this.candidatesLoading = true;

        const [ candidates, error ] =
            await Subscriptions.MigrationCandidates( this.selectedPlanIds );

        this.candidatesLoading = false;

        if( error !== undefined ) {
            this.migrateStep = "plans";
            EventBus.Publish( "Error", error );
            return;
        }

        this.candidates = candidates;
        this.selectedSubscriptionIds = candidates.map(
            ( candidate: MigrationCandidate ): number => candidate.Id
        );
    }

    private get visibleCandidates(): MigrationCandidate[] {
        const needle = this.candidateSearch.trim().toLowerCase();

        if( needle === "" )
            return this.candidates;

        return this.candidates.filter( ( candidate: MigrationCandidate ): boolean =>
            ( candidate.CustomerName + " " + candidate.PlanName ).toLowerCase().indexOf( needle )
                !== -1
        );
    }

    private isCandidateSelected( id: number ): boolean {
        return this.selectedSubscriptionIds.indexOf( id ) !== -1;
    }

    private toggleCandidate( id: number ): void {
        const index = this.selectedSubscriptionIds.indexOf( id );

        if( index === -1 )
            this.selectedSubscriptionIds.push( id );
        else
            this.selectedSubscriptionIds.splice( index, 1 );
    }

    /* « Tout cocher » porte sur les comptes AFFICHES ( la recherche en cours ). */
    private get allVisibleSelected(): boolean {
        return this.visibleCandidates.length > 0 && this.visibleCandidates.every(
            ( candidate: MigrationCandidate ): boolean => this.isCandidateSelected( candidate.Id )
        );
    }

    private toggleAllVisible(): void {
        const ids = this.visibleCandidates.map(
            ( candidate: MigrationCandidate ): number => candidate.Id
        );

        this.selectedSubscriptionIds = this.allVisibleSelected
            ? this.selectedSubscriptionIds.filter(
                ( id: number ): boolean => ids.indexOf( id ) === -1
            )
            : [ ...new Set( this.selectedSubscriptionIds.concat( ids ) ) ];
    }

    private formatAmount( value: number ): string {
        return new Intl.NumberFormat( this.$i18n.locale, {
            style: "currency",
            currency: "EUR"
        } ).format( value );
    }

    private formatDate( iso?: string ): string {
        return iso !== undefined && iso !== ""
            ? new Date( iso ).toLocaleDateString( this.$i18n.locale )
            : "—";
    }

    private recurrenceLabel( recurrence?: string ): string {
        if( recurrence === "Yearly" )
            return this.$t( "SUBSCRIPTIONS_recurrenceYearly" ).toString();

        if( recurrence === "Monthly" )
            return this.$t( "SUBSCRIPTIONS_recurrenceMonthly" ).toString();

        return "—";
    }

    private recurrenceUnit( recurrence?: string ): string {
        return this.$t( recurrence === "Yearly"
            ? "SUBSCRIPTIONS_recurrenceUnitYearly"
            : "SUBSCRIPTIONS_recurrenceUnitMonthly" ).toString();
    }

    private amountClass( candidate: MigrationCandidate ): string {
        if( candidate.After > candidate.Before )
            return "c-product-migrate__up";

        return candidate.After < candidate.Before ? "c-product-migrate__down" : "";
    }

    private onMigrateAction(): void {
        if( this.migrateStep === "plans" )
            this.loadCandidates();
        else
            this.migrateAll();
    }

    private isPlanSelected( id: number ): boolean {
        return this.selectedPlanIds.indexOf( id ) !== -1;
    }

    private togglePlan( id: number ): void {
        const index = this.selectedPlanIds.indexOf( id );

        if( index === -1 )
            this.selectedPlanIds.push( id );
        else
            this.selectedPlanIds.splice( index, 1 );
    }

    private get migrateAction() {
        if( this.migrateStep === "plans" )
            return {
                Id: "candidates",
                Name: this.$t( "SUBSCRIPTIONS_migrateSeeAccounts" ),
                Active: this.selectedPlanIds.length > 0 && !this.migrating
            };

        return {
            Id: "migrate",
            Name: this.$t( "SUBSCRIPTIONS_migrateApplyTo", {
                count: this.selectedSubscriptionIds.length
            } ),
            Active: this.selectedSubscriptionIds.length > 0
                && !this.candidatesLoading
                && !this.migrating
        };
    }

    /* Apply the published prices to existing customers, scoped to the selected plans. When every
       plan is selected we send an empty list so the backend keeps its blanket path (which also
       covers subscriptions billing global, planless prices). */
    private async migrateAll(): Promise<void> {
        this.showMigrate = false;
        this.migrating = true;
        this.migrateProgress = { Examined: 0, Total: 0, Migrated: 0 };

        const allSelected = this.selectedPlanIds.length === this.record.Plans.length;
        const planIds = allSelected ? [] : this.selectedPlanIds;

        let cursorId = 0;
        let totalMigrated = 0;
        let totalExamined = 0;
        let total = 0;
        const failures: MigrateFailure[] = [];

        /* One RunId for the whole campaign so every batch's history rows group under a single run
           in the migration history. Without it the backend skips logging (runId === "") and the
           run never shows up. */
        const runId = `run-${ Date.now() }`;

        /* Drive the bulk migration one bounded batch at a time, passing the previous batch's cursor
           back, so re-billing many customers never runs inside one long request that would 502.
           The cursor strictly decreases each batch (candidates are processed Id-descending), so the
           loop always terminates; HasMore stops it once no candidate remains. */
        for( ; ; ) {
            const [ batch, error ] =
                await Subscriptions.MigrateAll(
                    this.$i18n.locale, planIds, cursorId, runId, this.selectedSubscriptionIds
                );

            if( error !== undefined || batch === undefined ) {
                this.migrating = false;
                this.migrateProgress = undefined;
                EventBus.Publish( "Error", error );
                return;
            }

            totalMigrated += batch.Migrated;
            totalExamined += batch.Examined;
            total = batch.Total;
            failures.push( ...batch.Failures );
            cursorId = batch.NextCursor;

            this.migrateProgress = {
                Examined: totalExamined,
                Total: total,
                Migrated: totalMigrated
            };

            if( !batch.HasMore || batch.Examined === 0 )
                break;
        }

        /* Snap the bar to 100% and let it paint before tearing the modal down, so the run reads as
           complete instead of the bar vanishing mid-fill (a fast single-batch run never painted an
           intermediate value). A zero-candidate run shows a full bar too. */
        const done = total > 0 ? total : 1;
        this.migrateProgress = { Examined: done, Total: done, Migrated: totalMigrated };

        await this.$nextTick();
        await new Promise<void>( ( resolve ): void => { window.setTimeout( resolve, 600 ); } );

        this.migrating = false;
        this.migrateProgress = undefined;

        /* Let the Plans tab refresh its "prices not applied to everyone" column labels. */
        EventBus.Publish( "SubscriptionsMigrated" );

        /* Surface per-subscription failures in the console for diagnosis — the success notification
           only carries the migrated count, matching the previous single-shot behaviour. */
        if( failures.length > 0 )
            console.warn( "[MigrateAll] failures", failures );

        EventBus.Publish( "Notification", CustomNotification.Success(
            this.$t( "SUBSCRIPTIONS_migrateAllTitle" ).toString(),
            this.$t( "SUBSCRIPTIONS_migrateAllDone", { count: totalMigrated } ).toString()
        ));
    }

    @Watch( "record" )
    private onRecordChange( record?: Product ) {
        if( record === undefined )
            return;

        setTimeout( () => this.loading = record.Name === undefined, 200 );
    }
}
